// Reveals a play button when the browser refuses to autoplay (iOS Low Power Mode, Android Data Saver).
(() => {
  const PAUSED_CHECK_DELAY = 800;

  const init = (root) => {
    if (root.hasAttribute('data-product-video-ready')) {
      return;
    }
    root.setAttribute('data-product-video-ready', '');

    const video = root.querySelector('video');
    const playButton = root.querySelector('[data-product-video-play]');

    if (!video || !playButton) {
      return;
    }

    const showButton = () => {
      playButton.hidden = false;
    };
    const hideButton = () => {
      playButton.hidden = true;
    };

    video.addEventListener('playing', hideButton);
    video.addEventListener('pause', showButton);

    const requestPlay = (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      const resumed = video.play();

      if (resumed && typeof resumed.catch === 'function') {
        resumed.catch(showButton);
      }
    };

    playButton.addEventListener('click', requestPlay);

    // The video has pointer-events: none, so taps land here and the whole poster becomes tappable.
    root.addEventListener('click', (event) => {
      if (playButton.hidden || event.target.closest('[data-product-video-play]')) {
        return;
      }

      requestPlay(event);
    });

    const attempt = video.play();

    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(showButton);
    }

    // Some browsers resolve play() and then leave the video paused, so check the state too.
    window.setTimeout(() => {
      if (video.paused) {
        showButton();
      }
    }, PAUSED_CHECK_DELAY);
  };

  const initAll = () => document.querySelectorAll('[data-product-video]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
